import React, { useState, useEffect } from "react";
import api, { fmtFull } from "@/lib/api";
import { Loader2, Brain, CheckCircle2, AlertTriangle } from "lucide-react";

export default function AlertsTab() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/accounting/alerts").then(r => { setData(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="w-6 h-6 text-lime-400 animate-spin" /></div>;
  if (!data) return null;

  const severityColor = { critical: "border-red-500/30 bg-red-500/5", high: "border-amber-500/30 bg-amber-500/5", medium: "border-sky-500/30 bg-sky-500/5", low: "border-slate-500/30 bg-slate-500/5" };
  const severityIcon = { critical: "text-red-400", high: "text-amber-400", medium: "text-sky-400", low: "text-slate-400" };

  return (
    <div className="space-y-4" data-testid="acct-alerts">
      <h2 className="text-sm font-bold text-slate-200 flex items-center gap-2"><Brain className="w-4 h-4 text-lime-400" /> AI Canh bao bat thuong</h2>
      {data.alerts?.length === 0 && (
        <div className="text-center py-12"><CheckCircle2 className="w-10 h-10 text-emerald-400 mx-auto mb-3" /><p className="text-sm text-slate-400">Khong phat hien bat thuong. Moi so lieu on dinh.</p></div>
      )}
      <div className="space-y-2">
        {data.alerts?.map((a, i) => (
          <div key={i} className={`rounded-xl border p-3 ${severityColor[a.severity] || severityColor.low}`}>
            <div className="flex items-center gap-2 mb-1">
              <AlertTriangle className={`w-4 h-4 ${severityIcon[a.severity] || severityIcon.low}`} />
              <p className="text-sm font-medium text-slate-200">{a.title}</p>
            </div>
            <p className="text-xs text-slate-400">{a.detail}</p>
          </div>
        ))}
      </div>
      {data.summary && (
        <div className="bg-[#1e293b] border border-[#334155] rounded-xl p-4 mt-4">
          <p className="text-xs text-slate-400 mb-2">Tom tat thang nay</p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-2 text-xs">
            <div><span className="text-slate-600">Tong thu:</span> <span className="text-emerald-400 font-medium">{fmtFull(data.summary.total_thu)}</span></div>
            <div><span className="text-slate-600">Tong chi:</span> <span className="text-red-400 font-medium">{fmtFull(data.summary.total_chi)}</span></div>
            <div><span className="text-slate-600">TB thu/ngay:</span> <span className="text-slate-300">{fmtFull(data.summary.daily_avg_thu)}</span></div>
            <div><span className="text-slate-600">TB chi/ngay:</span> <span className="text-slate-300">{fmtFull(data.summary.daily_avg_chi)}</span></div>
            <div><span className="text-slate-600">Luong thang:</span> <span className="text-purple-400">{fmtFull(data.summary.salary_current)}</span></div>
            <div><span className="text-slate-600">Luong thang truoc:</span> <span className="text-slate-400">{fmtFull(data.summary.salary_prev)}</span></div>
          </div>
        </div>
      )}
    </div>
  );
}
